import { NavLink } from "react-router-dom";

export default function AftersalesExploreService({showItem}) {
    const serviceItems = [
        {
            'title' : 'Services',
            'image' : '/assets/services.png',
            'url' : '/services'
        },
        {
            'title' : 'Products',
            'image' : '/assets/home-card-img2.png',
            'url' : '/products'
        },
        {
            'title' : 'Warranty',
            'image' : '/assets/warrenty-img.png',
            'url' : '/warranty'
        },
        {
            'title' : 'T-CARE',
            'image' : '/assets/T-care.png',
            'url' : '/t-care'
        },
        {
            'title' : 'Hybrid Health Check',
            'image' : '/assets/hybrid_health_check.jpg',
            'url' : '/hybrid-health-check'
        },
        {
            'title' : 'News & Events',
            'image' : '/assets/news_event.png',
            'url' : '/news-information'
        },
        {
            'title' : 'FAQ',
            'image' : '/assets/home-card-img1.png',
            'url' : '/faq'
        },
    ];


    return <div className="section-3 mt-5">
        <div className="container">
            <h5 className="fw-bold title-2 mb-5">Telusuri lebih lanjut terkait After Sales Toyota</h5>

            <div className="row justify-content-center">
                {serviceItems.filter((_, index) => showItem.includes(index)).map((item) => (
                    <div className="col-md-4 mb-5">
                        <div className="card custom_box_shadow">
                            <img
                                src={item.image}
                                className="rounded-0"
                                alt={item.title}
                            />
                            <div className="card-body">
                                <h4 className="card-title service_card_title fw-bold">{item.title}</h4>
                                <NavLink to={item.url}>
                                    <button type="button" class="btn btn-outline-dark w-100 py-1 mt-4">
                                        Telusuri Sekarang
                                    </button>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            {/* <div className="logos d-flex justify-content-center mt-5 mb-4">
                <div className="mx-2">
                    <img src="/assets/quality-service.png" alt="t-care-img" />
                </div>
                <div className="mx-2">
                    <img src="/assets/genuine-parts (1).png" alt="t-care-img" />
                </div>
            </div> */}
        </div>
    </div>
}